import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, DropdownOutline, DropdownTrigger } from 'frontend/js/modules/infra/ui/dropdown';
import { t } from 'frontend/js/modules/infra/i18n';
import PromotionIcon from '../../../icons/campaign-type-promotion.svg';
import UpdateIcon from '../../../icons/campaign-type-update.svg';
import AllTypesIcon from '../../../icons/campaign-type-all.svg';
import styles from './styles.module.scss';
import { ButtonOption, DropdownList } from '../../dropdown-list';
var typeOptions = [
    {
        labelKey: 'engage:filters.all_campaign_types',
        value: 'all',
        TypeIcon: AllTypesIcon,
    },
    {
        labelKey: 'engage:filters.quick_update',
        value: 'update',
        TypeIcon: UpdateIcon,
    },
    {
        labelKey: 'engage:filters.promotion',
        value: 'promotion',
        TypeIcon: PromotionIcon,
    },
];
export var TypeFilterDropdown = function (_a) {
    var _b;
    var typeFilter = _a.typeFilter, setTypeFilter = _a.setTypeFilter;
    return (_jsx("div", { className: styles['extra-filter-dropdown__container'], children: _jsxs(Dropdown, { "data-automation-id": "type-filter-dropdown", children: [_jsx(DropdownTrigger, { className: styles['extra-filter-dropdown'], children: _jsx(DropdownOutline.Trigger, { label: t(((_b = typeOptions.find(function (option) { return option.value === typeFilter; })) === null || _b === void 0 ? void 0 : _b.labelKey) || 'engage:filters.all_campaign_types') }) }), _jsx(DropdownList, { children: typeOptions.map(function (typeOption) { return (_jsxs(ButtonOption, { id: "filter-engage-list-by-type-".concat(typeOption.value), onClick: function () { return setTypeFilter(typeOption.value); }, children: [_jsx(typeOption.TypeIcon, {}), t(typeOption.labelKey)] }, typeOption.value)); }) })] }) }));
};
